import { Box } from "@drone-js/core";
import type { FunctionComponent } from "react";
import { HeroContent } from "./HeroContent";
import { HeroImage } from "./HeroImage";

export const HeroSection: FunctionComponent = () => {
    return (
        <Box
            width="100%"
            backgroundColor="base.surface"
            pt="64"
            position="relative"
            overflowY="hidden"
            data-element-name="hero-section"
        >
            <Box pt="12">
                <HeroContent />
                <HeroImage />
            </Box>
        </Box>
    );
};
